import { ActionReducerMap } from '@ngrx/store';
import { SeoState } from './state';
import { plpSeoReducer } from './plp-seo';

export const reducers: ActionReducerMap<SeoState> = {
  plpSeo: plpSeoReducer
};
